import { type ApiClient, listQueryParams } from "./client";
import type { AiRunDetail, AiRunFilters, AiRunRow, AiSummary, DateRange, ListQuery, Page } from "./types";

/** Ai: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface AiApi {
  summary(range: DateRange): Promise<AiSummary>;
  listRuns(query: ListQuery<AiRunFilters>): Promise<Page<AiRunRow>>;
  getRun(id: string): Promise<AiRunDetail>;
}

export function createHttpAiApi(client: ApiClient): AiApi {
  return {
    summary: (range) => client.call("getAiSummary", { query: { range } }),
    listRuns: (q) => client.call("listAiRuns", { query: listQueryParams(q) }),
    getRun: (id) => client.call("getAiRun", { params: { id } }),
  };
}
